import { Component, Input } from '@angular/core';
import { Bac } from '@app/library/models/bac.model';
import { OpenFilterEditPanel } from '@app/library/states/filters.actions';
import { FiltersState } from '@app/library/states/filters.state';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'rk-library-filter-button',
  templateUrl: './library-filter-button.component.html',
  styleUrls: ['./library-filter-button.component.scss'],
})
export class LibraryFilterButtonComponent {
  @Input() set bac(value: Bac) {
    this._bac = value;
    this.isBacHavingFilters$ = this.store
      .select(FiltersState.hasBacAnyFilter)
      .pipe(map(fn => fn(value.id)));
  }

  get bac(): Bac {
    return this._bac;
  }

  private _bac: Bac;

  isBacHavingFilters$: Observable<boolean>;

  constructor(private readonly store: Store) {
    this.isBacHavingFilters$ = of(false);
  }

  @Dispatch()
  openFilter = () => new OpenFilterEditPanel(this._bac.id);
}
